var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.value),function(applicantForm){return _c('vg-card',{key:JSON.stringify(applicantForm)},[_c('vg-view-field-list',{staticClass:"space-between"},_vm._l((applicantForm.fields),function(field){return _c('dp-application-view-field',{key:field.applicationAttributeFieldId,attrs:{"value":field,"maximum":""}})}),1)],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }